import withRouter from '../../shared/utils/WithRouter';
import NotFound from './NotFound';

// generate a route-aware container component
const NotFoundContainer = withRouter(NotFound);

export default NotFoundContainer;
